import { useAuthContext } from '@/hooks/useAuth';
import { useFeatureAccess } from '@/components/plan/FeatureGate';
import { isRepeatEnabled } from '@/lib/repeatGate';

/**
 * #4038 / HAM-3471 リピート cutover（案B: owner 完全非露出）の単一述語。
 *
 * 「このユーザーは repeat-first owner か」= 本番昇格された owner→/repeat リダイレクト
 * gate が bounce する対象か、を表す steady-state 条件。
 * `RepeatRedirectGate`（routing 層・loading guard を上に重ねる）と全 nav の
 * 「ダッシュボード導線を隠すか」が**この単一述語**を共有することで、
 * redirect 対象と nav 非表示対象の drift を構造的に防ぐ。
 *
 * 条件:
 * - `isRepeatEnabled()`: build-time flag `VITE_REPEAT_ENABLED`（default OFF）。
 *   OFF の間は常に false ＝ 本番無影響（rollback も再ビルドでこの flag を落とすだけ）。
 * - `role === 'owner'`: 案B は owner スコープ。staff は /dashboard 継続ゆえ false。
 * - `useFeatureAccess('repeat')`: Light+ plan。未保有 owner は /dashboard 継続（leak でない）。
 *
 * NOTE: 早期/初期化中の timing guard（isInitializing / subscription loading）は含めない。
 * redirect 副作用を持つ gate 側でのみ重ねる。nav は表示判定ゆえ steady-state で十分。
 */
export function useIsRepeatFirstOwner(): boolean {
  const { user } = useAuthContext();
  const hasRepeatAccess = useFeatureAccess('repeat');

  return isRepeatEnabled() && user?.role === 'owner' && hasRepeatAccess;
}
